import {useRouterSnapshot} from './useRouterSnapshot';

/**
 * Reactive current pathname: subscribes to router navigation, so consumers
 * re-render when the route changes — unlike reading `window.location.pathname`
 * during render, which the React Compiler memoizes as dependency-free (the
 * active-nav highlight froze on the first route this way). Falls back to the
 * window location when rendered without a `RouterProvider` (plain RTL renders).
 */
export function usePathname(): string {
  const {state} = useRouterSnapshot();
  if (state) {
    return state.location.pathname;
  }
  return typeof window !== 'undefined' ? window.location.pathname : '';
}
